module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "pdf"
    }
  }, _vm._l((_vm.grouped), function(value, key) {
    return _c('div', {
      key: key,
      attrs: {
        "id": "rowcicle"
      }
    }, [_c('div', {
      attrs: {
        "id": "rowlogos"
      }
    }, [_c('img', {
      staticClass: "logo_leak",
      attrs: {
        "id": "leak",
        "width": "200px",
        "src": _vm.logoUrl
      }
    })]), _vm._v(" "), _c('h4', {
      attrs: {
        "id": "h41"
      }
    }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('hr', {
      staticClass: "yellow__hr",
      attrs: {
        "id": "hr1"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pdf__info",
      attrs: {
        "id": "pdf_info"
      }
    }, [_c('p', [_c('span', {
      staticClass: "pdf__titles",
      attrs: {
        "id": "titles"
      }
    }, [_vm._v(" Estación: ")]), _vm._v(" " + _vm._s(key) + " ")]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pdf__titles",
      attrs: {
        "id": "titles"
      }
    }, [_vm._v(" Ducto: ")]), _vm._v(" " + _vm._s(_vm.duct) + " ")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "tablecontainer"
      }
    }, [_c('table', {
      attrs: {
        "id": "tableholder"
      }
    }, [_c('thead', {
      attrs: {
        "id": "header"
      }
    }, [_c('tr', {
      attrs: {
        "id": "trh"
      }
    }, [_c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Fecha de Solicitud")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Mensaje")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Fecha de Recepción")]), _vm._v(" "), _c('th', {
      staticClass: "title__td",
      attrs: {
        "id": "thh"
      }
    }, [_vm._v("Presión")]), _vm._v(" "), (_vm.showViewColumn === 'true') ? _c('th', {
      staticClass: "title__td print-hidden",
      attrs: {
        "id": "thh"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((value), function(a) {
      return _c('tr', {
        class: {
          'highlight': a.samePressure
        },
        attrs: {
          "id": "trw"
        }
      }, [_c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.r_ts) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.r_f) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_vm._v(" " + _vm._s(a.i_ts) + " ")]), _vm._v(" "), _c('td', {
        attrs: {
          "id": "tdc"
        }
      }, [_c('span', {
        class: {
          'highlight': a.samePressure
        }
      }, [_vm._v(" " + _vm._s(a.p) + " ")])]), _vm._v(" "), (_vm.showViewColumn === 'true') ? _c('td', {
        staticClass: "print-hidden"
      }, [_c('div', {
        staticClass: "center-option"
      }, [_c('i', {
        staticClass: "fa fa-eye",
        attrs: {
          "aria-hidden": "true",
          "title": "Ver detalles"
        },
        on: {
          "click": function($event) {
            return _vm.open(a)
          }
        }
      })])]) : _vm._e()])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "bottom-offset",
      attrs: {
        "id": 'imgChart-' + _vm.filterLettersAndNumbers(key)
      }
    }), _vm._v(" "), _c('div', {
      class: {
        'hide-line-chart': _vm.isChartDisplayed
      },
      attrs: {
        "id": "linechart"
      }
    }, [_c('line-chart', {
      class: _vm.filterLettersAndNumbers(key),
      staticStyle: {
        "opacity": "0.0"
      },
      attrs: {
        "chartData": _vm.getChartDataFromSite({
          key: key,
          value: value
        }),
        "options": _vm.chartOptions,
        "width": 300,
        "height": 200
      },
      on: {
        "onAnimationComplete": _vm.onAnimationComplete
      }
    })], 1)])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-218db49c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reportes/PdfDiv.vue
// module id = 1691
// module chunks = 6